var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    attrs: { disabled: _vm.disabled },
    on: { change: _vm.onVesselAndVoyageChange },
    model: {
      value: _vm.vesselAndVoyage,
      callback: function($$v) {
        _vm.vesselAndVoyage = $$v
      },
      expression: "vesselAndVoyage"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }